import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './ContactPage.module.css';

function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className={styles.contentSection}>
      <h2 className={styles.title}>{t('contact.title', 'Contact')}</h2>

      <section className={styles.card}>
        <h3 className={styles.cardTitle}>{t('contact.instagram')}</h3>
        <p className={styles.text}>
          {t('contact.followOnInstagram')} {' '}
          <a
            className={styles.link}
            href="https://www.instagram.com/peaksonfoot/"
            target="_blank"
            rel="noopener noreferrer"
          >
            @peaksonfoot
          </a>
        </p>
      </section>

      <section className={styles.card}>
        <h3 className={styles.cardTitle}>{t('contact.emailTitle', 'Email')}</h3>
        <p className={styles.text}>{t('contact.emailIntro')}</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <a className={styles.link} href="mailto:admin@peaksonfoot.com">admin@peaksonfoot.com</a>
            <span className={styles.muted}> — {t('contact.admin')}</span>
          </li>
          <li className={styles.listItem}>
            <a className={styles.link} href="mailto:support@peaksonfoot.com">support@peaksonfoot.com</a>
            <span className={styles.muted}> — {t('contact.support')}</span>
          </li>
          <li className={styles.listItem}>
            <a className={styles.link} href="mailto:legal@peaksonfoot.com">legal@peaksonfoot.com</a>
            <span className={styles.muted}> — {t('contact.legal')}</span>
          </li>
          <li className={styles.listItem}>
            <a className={styles.link} href="mailto:privacy@peaksonfoot.com">privacy@peaksonfoot.com</a>
            <span className={styles.muted}> — {t('contact.privacyEmail')}</span>
          </li>
        </ul>
        <p className={styles.text}>
          {t('contact.privacyIntro')}{' '}
          <Link className={styles.link} to="/privacy">{t('common.privacyPolicy')}</Link>.
        </p>
      </section>

      <section className={styles.card}>
        <h3 className={styles.cardTitle}>{t('contact.legalInfoTitle')}</h3>
        <p className={styles.text}>{t('contact.legalInfoBody')}</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <strong>{t('contact.responsible')}</strong>
            <span className={styles.muted}> Krisztian Gal</span>
          </li>
          <li className={styles.listItem}>
            <strong>{t('contact.address')}</strong>
            <span className={styles.muted}> Mustaherukkatie 6, 90800 Oulu, Finland</span>
          </li>
          <li className={styles.listItem}>
            <strong>{t('contact.personalContact')}</strong>
            <span className={styles.muted}> </span>
            <a className={styles.link} href="mailto:contact@krisztian.fi">contact@krisztian.fi</a>
          </li>
        </ul>
      </section>
    </div>
  );
}

export default ContactPage;
